import { Component, EventEmitter, Input, Output, OnInit, OnChanges, SimpleChanges, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { WorkerLegalizationAgreementDto } from '../../../../models/dtos/worker-legalization-agreement-dto';
import { LegalizationService } from '../../../../data/legalization.service';

@Component({
    selector: 'app-agreements-section',
    templateUrl: './agreements-section.component.html',
    styleUrl: './agreements-section.component.scss',
    standalone: false
})
export class AgreementsSectionComponent implements OnInit, OnChanges {
    private legalizationService = inject(LegalizationService);

    @Input() workerId: number;
    @Input() preSelectedAgreements: number[] = [];
    @Input() disabledSelectedAgreements: number[] = [];
    @Input() disabled: boolean = false;
    @Output() agreementsSelectionChange = new EventEmitter<number[]>();

    public showOnlyActiveAgreements: boolean = true;
    public listOfAgreements$: Observable<WorkerLegalizationAgreementDto[]> = of([]);
    private selectedAgreements: number[] = [];

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() { }

    ngOnInit(): void {
        this.loadAgreements();
        this.updateSelectedAgreements();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['preSelectedAgreements'] && !changes['preSelectedAgreements'].firstChange) {
            this.updateSelectedAgreements();
        }
    }

    private updateSelectedAgreements(): void {
        if (this.preSelectedAgreements && this.preSelectedAgreements.length > 0) {
            this.selectedAgreements = [...this.preSelectedAgreements];
            this.agreementsSelectionChange.emit(this.selectedAgreements);
        }
    }

    isAgreementSelected(agreementId: number): boolean {
        return this.selectedAgreements.includes(agreementId);
    }

    isGivenAgreementDisabled(agreementId: number): boolean {
        return this.disabledSelectedAgreements.includes(agreementId);
    }

    onAgreementToggle(legalizationId: number, event: { checked: boolean }): void {
        if (event.checked) {
            this.selectedAgreements.push(legalizationId);
        } else {
            this.selectedAgreements = this.selectedAgreements.filter(id => id !== legalizationId);
        }
        this.agreementsSelectionChange.emit(this.selectedAgreements);
    }

    onShowOnlyActiveAgreementsChange(event: { checked: boolean }): void {
        this.showOnlyActiveAgreements = event.checked;
        this.loadAgreements();
    }

    private loadAgreements(): void {
        this.listOfAgreements$ = this.legalizationService.getWorkerLegalizationAgreements(
            this.workerId,
            !this.showOnlyActiveAgreements
        );
    }
}
